import script from "./MoreInformationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MoreInformationModal.vue?vue&type=script&setup=true&lang=js"

import "./MoreInformationModal.vue?vue&type=style&index=0&id=20fe22bc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20fe22bc"]])

export default __exports__